import React, {Component} from 'react';

import _ from "lodash";

import TripTruckScaleTicket from "./TripTruckScaleTicket";
import helpers from "../../../../../utils/helpers";
import formatters from "../../../../../utils/formatters";

export default class TripSummary extends Component {

    render() {
        let trip = this.props.trip;
        if(!trip)return <div />;
        let {product, order_volume, provider_load_volume, kgs_dispatched_by_the_provider,  entry_weight,
            exit_weight, weight_control, meter_worked, movements_observations, final_observations,
            net_weight, unload_volume, unload_weight, weight_control_observations,
            cancellation_observations, rejection_reason, rejection_observations
        } = trip;

        let result_color = 'green';
        let result_icon = 'check_circle';

        if(!weight_control){
            result_color = 'red';
            result_icon = 'cancel';
        }

        let images = {
            dispatch: '/static/images/summary/dispatch.png',
            entry: '/static/images/summary/entry.png',
            discharge: '/static/images/summary/discharge.png',
            exit: '/static/images/summary/exit.png'
        };

        let showDetail = {
            dispatch: true,
            entry: true,
            discharge: true,
            exit: true
        };

        let subtitle = 'Resultado de la balanza';
        let status = trip.status.id;

        let wasCanceled = false;
        let wasRejected = false;

        if(helpers.states.canceled.indexOf(status) > -1){
            subtitle = <span className={"red-text"}>Viaje cancelado</span>;
            images['entry'] = '/static/images/summary/grey-entry.png';
            images['discharge'] = '/static/images/summary/grey-discharge.png';
            images['exit'] = '/static/images/summary/grey-exit.png';

            showDetail['dispatch'] =  false;
            showDetail['entry'] =  false;
            showDetail['discharge'] =  false;
            showDetail['exit'] =  false;

            wasCanceled = true;
        }

        if(helpers.states.rejected.indexOf(status) > -1){
            subtitle = <span className={"red-text"}>Viaje rechazado</span>;
            images['exit'] = '/static/images/summary/grey-exit.png';

            showDetail['discharge'] =  false;
            // showDetail['exit'] =  false;
            wasRejected = true;
        }

        let emptyBox = <div className={"summary-box-detail center"}><i className={"grey-text"}>-</i></div>;

        let orderLabel = '';
        let dispatchLabel = '';
        let dischargeLabel = '';
        if(product){
            if(product.order_unit_of_measure){
                orderLabel = _.capitalize(product.order_unit_of_measure);
                if(product.order_density){
                    orderLabel = `${orderLabel} a ${formatters.floatFormat(product.order_density)}º`;
                }
            }
            if(product.origin_unit_of_measure){
                dispatchLabel = _.capitalize(product.origin_unit_of_measure);
                if(product.origin_density){
                    dispatchLabel = `${dispatchLabel} a ${formatters.floatFormat(product.origin_density)}º`;
                }
            }
            if(product.terminal_unit_of_measure){
                dischargeLabel = _.capitalize(product.terminal_unit_of_measure);
                if(product.terminal_density){
                    dischargeLabel = `${dischargeLabel} a ${formatters.floatFormat(product.terminal_density)}º`;
                }
            }
        }

        return (
            <div>
                <div className={"row"}>
                    <div className={"col s12 summary-box no-padding"}>
                        <div className={"summary-info-product"}>
                            {_.capitalize(product.name)}
                            <div className={"summary-scale-result"}>
                                {subtitle}
                                <i className={`material-icons ${result_color}-text`}>{result_icon}</i>
                            </div>
                        </div>
                        <div className={"summary-info"}>
                            {order_volume &&
                            <div>
                                <div className={"summary-info-result"}>
                                    Orden
                                </div>
                                <div className={"summary-box-detail"}>
                                    Orden en {orderLabel}
                                    <div className={"summary-box-number"}>{formatters.intFormat(order_volume)}</div>
                                </div>
                            </div>
                            }
                            <div className={"summary-info-result margin-top-20"}>
                                Balanza
                                <TripTruckScaleTicket trip={trip} />
                            </div>
                            <div>
                                <div className={"summary-box-detail"}>
                                    Bruto en Kg
                                    <div className={"summary-box-number"}>{formatters.intFormat(entry_weight)}</div>
                                </div>
                                <div className={"summary-box-detail"}>
                                    Tara en Kg
                                    <div className={"summary-box-number"}>(-) {formatters.intFormat(exit_weight)}</div>
                                </div>
                                <div className={`summary-box-detail summary-box-detail-bold summary-box-result-${result_color}`}>
                                    Neto en Kg
                                    <div className={"summary-box-number"}>{formatters.floatFormat(net_weight)}</div>
                                </div>
                            </div>
                        </div>
                        <div className={"summary-trucks"}>
                            <div className={"row"}>
                                <div className={"col s3"}>
                                    <i className={"material-icons right-chevron"}>keyboard_arrow_right</i>
                                    <div className={"center"} style={{position: 'relative'}}>
                                        <img src={images.dispatch} alt={"Despacho"} />
                                        {wasCanceled &&
                                        <i className={"material-icons red-text trip-image-cancel"}>cancel</i>
                                        }
                                    </div>
                                    <p className={"center no-margin"}>Despacho</p>
                                    {showDetail.dispatch &&
                                    <div>
                                        <div className={`summary-box-detail summary-box-detail-bold`}>
                                            Despacho en {dispatchLabel}
                                            <div className={"summary-box-number"}>{formatters.intFormat(provider_load_volume)}</div>
                                        </div>
                                        {kgs_dispatched_by_the_provider &&
                                        <div className={`summary-box-detail summary-box-detail-bold`}>
                                            Despacho en Kg
                                            <div
                                                className={"summary-box-number"}>{formatters.intFormat(kgs_dispatched_by_the_provider)}</div>
                                        </div>
                                        }
                                    </div>
                                    }
                                    {!showDetail.dispatch &&
                                        <div className={"summary-box-detail center"} style={{borderColor: 'red'}}>
                                            <b className={"red-text"}>Viaje cancelado</b>
                                        </div>
                                    }
                                </div>
                                <div className={"col s3"}>
                                    <i className={"material-icons right-chevron"}>keyboard_arrow_right</i>
                                    <div className={"center"} style={{position: 'relative'}}>
                                        <img src={images.entry} alt={"Entrada"} />
                                    </div>
                                    <p className={"center no-margin"}>Balanza de entrada</p>
                                    {showDetail.entry &&
                                    <div>
                                        <div className={"summary-box-detail"}>
                                            Bruto en Kg
                                            <div className={"summary-box-number"}>{formatters.intFormat(entry_weight)}</div>
                                        </div>
                                    </div>
                                    }
                                    {!showDetail.entry && emptyBox}
                                </div>
                                <div className={"col s3"}>
                                    <i className={"material-icons right-chevron"}>keyboard_arrow_right</i>
                                    <div className={"center"} style={{position: 'relative'}}>
                                        <img src={images.discharge} alt={"Descarga"} />
                                        {wasRejected &&
                                        <i className={"material-icons red-text trip-image-cancel"}>cancel</i>
                                        }
                                    </div>
                                    <p className={"center no-margin"}>Descarga</p>
                                    {meter_worked && showDetail.discharge &&
                                    <div>
                                        <div className={"summary-box-detail"}>
                                            Descarga en {dischargeLabel}
                                            <div className={"summary-box-number"}>{formatters.intFormat(unload_volume)}</div>
                                        </div>
                                        <div className={`summary-box-detail summary-box-detail-bold`}>
                                            Descarga en Kg
                                            <div className={"summary-box-number"}>{formatters.intFormat(unload_weight)}</div>
                                        </div>
                                    </div>
                                    }
                                    {!meter_worked && showDetail.discharge &&
                                    <div>
                                        <div className={"summary-box-detail center"}>
                                            <i className={"grey-text"}>Sin Meter</i>
                                        </div>
                                    </div>
                                    }
                                    {!showDetail.discharge &&
                                        <div>
                                        {!wasRejected ? emptyBox :
                                            <div className={"summary-box-detail center"} style={{borderColor: 'red'}}>
                                            <b className={"red-text"}>No se realizó la descarga</b>
                                            </div>
                                        }
                                        </div>
                                    }
                                </div>
                                <div className={"col s3"}>
                                    <div className={"center"} style={{position: 'relative'}}>
                                        <img src={images.exit} alt={"Salida"} />
                                    </div>
                                    <p className={"center no-margin"}>Balanza de salida</p>
                                    {showDetail.exit &&
                                    <div>
                                        <div className={"summary-box-detail"}>
                                            Tara en Kg
                                            <div className={"summary-box-number"}>{formatters.intFormat(exit_weight)}</div>
                                        </div>
                                    </div>
                                    }
                                    {!showDetail.exit && emptyBox}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {wasCanceled &&
                <div className={"row thin-row"}>
                    <div className={"col s12 summary-box"} style={{padding: '10px 0'}}>
                        <div className={"row"}>
                            <div className={"col s12 input-field"}>
                                <label className="active">Observaciones de la cancelación</label>
                                <p className={"field-p"}>{cancellation_observations ? cancellation_observations : <i className={"grey-text"}>No hay comentarios</i>}</p>
                            </div>
                        </div>
                    </div>
                </div>
                }
                {wasRejected &&
                <div className={"row thin-row"}>
                    <div className={"col s12 summary-box"} style={{padding: '10px 0'}}>
                        <div className={"row"}>
                            <div className={"col s4 input-field"}>
                                <label className="active">Motivo del Rechazo</label>
                                <p className={"field-p"}>{rejection_reason ? rejection_reason.text : <i className={"grey-text"}>-</i>}</p>
                            </div>
                            <div className={"col s8 input-field"}>
                                <label className="active">Observaciones del Rechazo</label>
                                <p className={"field-p"}>{rejection_observations ? rejection_observations : <i className={"grey-text"}>No hay comentarios</i>}</p>
                            </div>
                        </div>
                    </div>
                </div>
                }
                <div className={"row"}>
                    <div className={"col s12 summary-box"} style={{padding: '10px 0'}}>
                        <div className={"row"}>
                            <div className={"col s4 input-field"}>
                                <label className="active">Observaciones de movimientos</label>
                                <p className={"field-p"}>{movements_observations ? movements_observations : <i className={"grey-text"}>No hay comentarios</i>}</p>
                            </div>
                            <div className={"col s4 input-field"}>
                                <label className="active">Observaciones de la balanza de salida</label>
                                <p className={"field-p"}>{weight_control_observations ? weight_control_observations  : <i className={"grey-text"}>No hay comentarios</i>}</p>
                            </div>
                            <div className={"col s4 input-field"}>
                                <label className="active">Observaciones finales operador ISS</label>
                                <p className={"field-p"}>{final_observations ? final_observations  : <i className={"grey-text"}>No hay comentarios</i>}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/Done/TripSummary.js